<template>
  <q-card
    id="_tlqn_admin_group_user_list_manage"
    class="q-px-lg q-pt-xl q-pb-md column justify-between"
    style="width: 80vw;max-width: 1200px;height: 80vh;max-height: 800px"
  >
    <header class="row items-center justify-center">
      <q-input
        dense
        filled
        label="搜索 样本名称"
        style="width: 50%"
        v-model="searchInput"
      />
      <q-icon
        name="fas fa-times-circle"
        class="absolute text-grey cursor-pointer"
        style="right: 50px"
        size="20px"
        @click="cancel()"
      />
    </header>

    <q-table
      style="max-height: calc(100% - 150px);height: calc(100% - 150px)"
      class="rounded-borders sticky-header-table q-my-md"
      :data="filteredSampleList"
      :columns="columnDef"
      :loading="loading"
      row-key="index"
      virtual-scroll
      :pagination.sync="pagination"
      :rows-per-page-options="[0]"
      separator="horizontal"
      hide-bottom
    >
      <template v-slot:top>
        <div class="full-width row justify-between">
          <div style="font-size: 1.2rem; font-weight: bold">
            <span> 共有{{ filteredSampleList.length }}个可分配的样本 </span>
            <span class="text-grey" style="font-size: 0.8rem">
              （ 其中，<span class="text-primary">{{ inGroupCount }}</span>
              个样本已分配到当前样本组，
              <span class="text-primary">{{ inOtherGroupCount }}</span>
              个样本已分配到其他样本组，
              <span class="text-primary">{{ noGroupCount }}</span>
              个样本尚未分配 ）
            </span>
          </div>

          <div class="q-py-sm text-red text-caption">
            <q-icon
              name="fas fa-exclamation-triangle"
              size="12px"
              class="q-mr-sm"
            ></q-icon>
            <span>仅显示未开始的样本</span>
          </div>
        </div>
      </template>
      <template v-slot:body="props">
        <q-tr :props="props">
          <q-td key="add" :props="props">
            <q-checkbox v-model="checkModel[props.row.id]" />
          </q-td>
          <q-td key="sample_id" :props="props">
            <MatchHighlight
              class-name="tlqn-ad-gmls-search-match"
              :keyword="searchInput"
              :text="props.row.detail.sample_id"
            />
          </q-td>
          <q-td key="sample_group" :props="props">
            <q-badge
              dense
              v-if="!props.row.sample_group"
              color="grey"
              text-color="white"
            >
              未分配
            </q-badge>
            <q-badge
              v-else-if="props.row.sample_group.id === groupId"
              color="green"
              text-color="white"
            >
              已分配到当前组
            </q-badge>
            <q-badge
              v-else-if="props.row.sample_group.id !== groupId"
              color="red"
              text-color="white"
            >
              已分配到其他组
            </q-badge>
          </q-td>
          <q-td key="name" :props="props">
            <MatchHighlight
              class-name="tlqn-ad-gmls-search-match"
              :keyword="searchInput"
              :text="props.row.detail.name"
            />
          </q-td>

          <q-td key="tel" :props="props">
            <a
              :href="`tel:${props.row.detail.tel}`"
              v-if="props.row.detail.tel"
            >
              {{ props.row.detail.tel }}
            </a>
            <span v-else class="text-caption text-grey">
              未找到电话
            </span>
          </q-td>
          <q-td key="dom" :props="props">
            <div
              style="max-width: 200px; white-space: pre-wrap"
              :label="props.row.detail.dom"
            >
              <MatchHighlight
                class-name="tlqn-ad-gmls-search-match"
                :keyword="searchInput"
                :text="props.row.detail.dom"
              />
            </div>
          </q-td>
        </q-tr>
      </template>
    </q-table>

    <footer style="height: 60px" class="row justify-end items-center">
      <q-btn outline color="grey-8" class="q-px-md" @click="cancel">
        取消
      </q-btn>
      <q-btn
        flat
        class="text-white bg-primary q-ml-sm q-px-md"
        :disable="!checkChanged"
        @click="updateSampleGroupSamples"
        :loading="loading"
      >
        确认
      </q-btn>
    </footer>
  </q-card>
</template>

<script>
import { fetchSampleListByQuery } from "@/api/endpoints/sample/fetchSampleListByQuery";
import { updateSampleGroupSamples } from "@/api/endpoints/sample-group/updateSampleGroupSamples";
import { roughlyToPlain } from "@/utils/roughly-to-plain";
const columnDef = [
  {
    name: "add",
    label: "加入样本组",
    align: "center",
    style: "width: 80px",
  },
  {
    name: "sample_id",
    label: "样本ID",
    field: "detail",
    align: "center",
  },
  {
    name: "sample_group",
    label: "样本状态",
    field: "sample_group",
    align: "center",
    sortable: true,
    style: "width: 100px",
  },
  {
    name: "name",
    label: "样本名称",
    field: "detail",
    align: "center",
    sortable: true,
  },
  {
    name: "tel",
    label: "联系电话",
    field: "tel",
    align: "center",
  },
  {
    name: "dom",
    label: "注册地址",
    field: "dom",
    align: "center",
  },
];
export default {
  components: {
    MatchHighlight: () => import("@/components/MatchHighlight"),
  },
  props: {
    groupId: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      searchInput: "",
      loading: true,
      sampleList: [],
      columnDef,
      pagination: {
        rowsPerPage: 0,
      },

      checkModel: {},
      orginCheck: {},
      checkInited: false,
    };
  },

  mounted() {
    this.getSampleList();
    this.initUserStateSort();
  },

  computed: {
    inGroupCount() {
      return this.filteredSampleList.filter(
        (s) => s.sample_group && s.sample_group.id === this.groupId
      ).length;
    },

    inOtherGroupCount() {
      return this.filteredSampleList.filter(
        (u) => u.sample_group && u.sample_group !== this.groupId
      ).length;
    },

    noGroupCount() {
      return this.filteredSampleList.filter((u) => !u.sample_group).length;
    },

    /**
     * 计算是否已选择过
     */
    checkChanged() {
      return (
        this.checkInited &&
        JSON.stringify(this.checkModel) !== JSON.stringify(this.orginCheck)
      );
    },

    filteredSampleList() {
      const { sampleList, searchInput } = this;
      return sampleList.filter((u) => {
        return (
          (u.detail &&
            u.detail.name &&
            u.detail.name.match(new RegExp(searchInput, "i"))) ||
          (u.detail &&
            u.detail.sample_id &&
            u.detail.sample_id.match(new RegExp(searchInput, "i"))) ||
          (u.detail &&
            u.detail.dom &&
            u.detail.dom.match(new RegExp(searchInput, "i")))
        );
      });
    },
  },

  methods: {
    initUserStateSort() {
      const t = this.columnDef.find((def) => def.name === "sample_group");
      const sort = (a, b, rowA, rowB) => {
        const getV = (id) => {
          if (!id) return 2;
          if (id === this.groupId) return 0;
          return 1;
        };
        return getV((a || {}).id) - getV((b || {}).id);
      };
      this.$set(t, "sort", sort);
    },

    /**
     * 获取样本组列表
     */
    async getSampleList() {
      try {
        const response = await fetchSampleListByQuery(
          { user: true },
          ["sample_id", "name", "is_enterprise", "dom", "tel"],
          { sample_status: 1 }
        );
        console.log(response);
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.sampleList = response;
          this.initCheck();
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({
          type: "danger",
          message: "获取用户列表时出现错误",
        });
      } finally {
        this.loading = false;
      }
    },

    /**
     * 初始化选择状态
     */
    initCheck() {
      const { sampleList } = this;
      this.checkModel = sampleList.reduce((res, sample) => {
        res[sample.id] = !!(
          sample.sample_group && sample.sample_group.id === this.groupId
        );
        return res;
      }, {});
      console.log(this.checkModel);
      this.orginCheck = roughlyToPlain(this.checkModel);
      this.checkInited = true;
    },

    cancel() {
      this.$emit("cancel");
    },

    async updateSampleGroupSamples() {
      this.loading = true;
      const { checkModel, orginCheck } = this;
      const append = [];
      const remove = [];
      const userIds = Object.keys(checkModel);
      for (let i = 0; i < userIds.length; i++) {
        const userId = userIds[i];
        if (checkModel[userId] === orginCheck[userId]) continue;
        (checkModel[userId] ? append : remove).push(userId);
      }
      try {
        const response = await updateSampleGroupSamples(this.groupId, {
          append,
          remove,
        });
        if (response.status && response.status !== 1) {
          this.$q.notify({
            type: "danger",
            message: "更新时发生未知错误",
          });
        } else {
          this.$q.notify({
            type: response.status ? "warning" : "success",
            message: `共添加${append.length}到样本组，成功${response.append_count}个，从样本组内移除${remove.length}个，成功${response.remove_count}个`,
          });
          this.$emit("updated");
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({
          type: "danger",
          message: "更新时发生未知错误",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";

.tlqn-ad-gmls-search-match {
  background-color: $primary;
  font-weight: bold;
  color: #fff;
  box-shadow: $shadow-1;
}

#_tlqn_admin_group_user_list_manage {
  .q-table__container {
    box-shadow: none;
    border: 1px solid rgba(0, 0, 0, 0.1) !important;
  }
}

.sticky-header-table {
  /* height: 310px; */
  border-radius: $generic-border-radius !important;

  .q-table__top,
  .q-table__bottom,
  thead tr:first-child th {
    background-color: $grey-2;
  }

  .q-table__middle.q-virtual-scroll.scroll {
    overflow: hidden;
    transition: all 0.1s ease;
    &:hover {
      overflow: auto;
    }
  }

  thead tr th {
    position: sticky;
    z-index: 1;
  }
  thead tr:first-child th {
    top: 0;
  }

  /* this is when the loading indicator appears */
  &.q-table--loading thead tr:last-child th {
    /* height of all previous header rows */
    top: 48px;
  }
}
</style>
